import { render, staticRenderFns } from "./IconDoc.vue?vue&type=template&id=155dfa62&"
import script from "./IconDoc.vue?vue&type=script&lang=js&"
export * from "./IconDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('155dfa62')) {
      api.createRecord('155dfa62', component.options)
    } else {
      api.reload('155dfa62', component.options)
    }
    module.hot.accept("./IconDoc.vue?vue&type=template&id=155dfa62&", function () {
      api.rerender('155dfa62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconDoc.vue"
export default component.exports